// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uAZE","newExpiryDate":"styles_newExpiryDate__2RkLG","footer":"styles_footer__2TYs4"};